<template>
  <span class="badge rounded-pill" :class="badgeClass">
    {{ $t(`forwards.common.status.${status}`) }}
  </span>
</template>

<script setup lang="ts">
import type { ForwardsBadgeStatus } from "@/forwards2/forwardsTypes";
import { computed } from "vue";

const props = defineProps<{
  status: ForwardsBadgeStatus;
}>();

// Bootstrap subtle pairs rather than a bespoke palette: these badges sit inside tables and card
// headers where the theme's own emphasis colours already read correctly in both brands.
const BADGE_CLASSES: Record<ForwardsBadgeStatus, string> = {
  draft: "bg-secondary-subtle text-secondary-emphasis",
  confirmed: "bg-primary-subtle text-primary-emphasis",
  completed: "bg-success-subtle text-success-emphasis",
  cancelled: "bg-danger-subtle text-danger-emphasis",
  archived: "bg-secondary-subtle text-secondary-emphasis",
  escrow_remaining: "bg-warning-subtle text-warning-emphasis",
  pay_as_produced: "bg-info-subtle text-info-emphasis",
};

const badgeClass = computed(() => BADGE_CLASSES[props.status]);
</script>
